import request from "@/utils/request";

//展示帮助中心列表
export function showProblem(params) {
  return request({
    url: "/shop/helpCenter/showProblem",
    method: "get",
    params
  });
}
// 展示帮助中心详情
export function showProblemDetail(id) {
  return request({
    url: `/shop/helpCenter/showProblemDetail/${id}`,
    method: "get"
  });
}
